module.exports = __webpack_public_path__ + "img/Weapon_57.f54efaf2.png";